const customerSearch = {
  searchResults: 'Inbox-CustomerSearch-SearchResults',
} as const;

const callBar = {
  callControls: 'Inbox-CallBar-CallControls',
} as const;

export const inboxLocators = {
  customerSearch,
  callBar,
};
